module.exports = __webpack_public_path__ + "static/media/blueIcon.1cacf2d0.svg";